module.exports = __webpack_public_path__ + "static/media/kite.cd1af6a4.svg";